const isValidNumber = (num) => !!Number(num) && !isNaN(num);

module.exports = (value, fixed = 2, dot = '.', space = ' ') => {
  if (!isValidNumber(value)) return '0';

  const strNum = String(value);
  const separator = strNum.includes(',') ? ',' : '.';

  const [left, right] = strNum.split(separator);

  let result = '';

  if (isValidNumber(left)) {
    const leftIsNegative = Number(left) < 0;

    const length = left.length;
    const resultArr = [];
    const finalIndex = leftIsNegative ? 1 : 0;

    for (let i = length - 1; i >= finalIndex; i--) {
      resultArr.push(left[i]);
      if (i > finalIndex && (length - i) % 3 === 0) resultArr.push(space);
    }

    if (leftIsNegative) resultArr.push('-');
    
    result = resultArr.reverse().join('');
  } else if (value < 0) {
    result = '-0';
  } else {
    result = '0';
  }

  if (isValidNumber(right)) {
    const pow = Math.pow(10, fixed);
    const roundedNumber = Math.round(strNum * pow) / pow;
    let roundedRight = String(roundedNumber).split(separator)[1];

    if (!roundedRight) {
      if (strNum.includes('.9')) {
        roundedRight = new Array(fixed).fill('9').join('');
      } else if (strNum.includes('01') && left === '0') {
        roundedRight = right;
      }
    }

    if (!!roundedRight) result += dot + roundedRight;
  }

  return result;
};
